export default "__VITE_ASSET__DJl7vvsH__"